import { IApplicationState } from '../../types/redux';

export const selectIsOpenModal = (state: IApplicationState): boolean => state.modal.isOpen;
